import { render, staticRenderFns } from "./TaskCallToAction.vue?vue&type=template&id=45ee0f60&scoped=true&"
import script from "./TaskCallToAction.vue?vue&type=script&lang=js&"
export * from "./TaskCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./TaskCallToAction.vue?vue&type=style&index=0&id=45ee0f60&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee0f60",
  null
  
)

export default component.exports